import { base64Decode, base64Encode } from '@/utils/base64';
import { AdoptionRequest } from './AdoptionRequest';
import { Item } from './Item';

export enum AdoptionEmailType {
  WELCOME = 'WELCOME',
  LMS_ADMIN = 'LMS_ADMIN',
  BOOKSTORE_ADMIN = 'BOOKSTORE_ADMIN',
  LMS = 'LMS',
}

export interface AdoptionEmail extends Item {
  // Page 1 In Order

  schoolId?: number;
  schoolName?: string;
  sentAt: Date;
  type: AdoptionEmailType;
  adoptionRequestId: number;
  adoptionRequest?: AdoptionRequest;
  recipient: string;
  sender: string;
  subject: string;
  body: string;
}

export const translateAdoptionEmailForTransport = (attributes: any): any => {
  return { ...attributes, body: base64Encode(attributes.body) };
};

export const translateAdoptionEmailFromTransport = (attributes: any): any => {
  return { ...attributes, body: base64Decode(attributes.body) };
};

export const translateAdoptionEmailTemplateForTransport = (attributes: any): any => {
  return {
    ...attributes,
    WELCOME: base64Encode(attributes.WELCOME),
    LMS_ADMIN: base64Encode(attributes.LMS_ADMIN),
    BOOKSTORE_ADMIN: base64Encode(attributes.BOOKSTORE_ADMIN),
  };
};

export const translateAdoptionEmailTemplateFromTransport = (attributes: any): any => {
  return {
    ...attributes,
    WELCOME: base64Decode(attributes.WELCOME),
    LMS_ADMIN: base64Decode(attributes.LMS_ADMIN),
    BOOKSTORE_ADMIN: base64Decode(attributes.BOOKSTORE_ADMIN),
  };
};
